import type { ExternalSiteCheckRule } from "../../types";
import { getNormalizedSixshopProHomeUrl } from "./common";
import { SITE_TYPE, SIXSHOP_PRO_PAGE } from "./const";

const getSixshopProPathname = (siteUrl: string, pathname: string): string => {
  const normalizedSiteUrl = getNormalizedSixshopProHomeUrl(siteUrl);

  if (
    normalizedSiteUrl.includes("sixshop3.site") ||
    normalizedSiteUrl.includes("sixshop.site")
  ) {
    const originPathnames = new URL(normalizedSiteUrl).pathname.split("/");
    const pathnames = pathname.split("/");
    const newPathname = [...originPathnames, ...pathnames]
      .filter((p) => Boolean(p))
      .join("/");
    return `/${newPathname}`;
  } else {
    const url = new URL(normalizedSiteUrl);
    url.pathname = pathname;

    return url.pathname;
  }
};

const sixshop: ExternalSiteCheckRule = {
  type: SITE_TYPE,

  checkPage({ url, target, siteUrl }) {
    if (target.value === "HOME") {
      if (url.pathname === getSixshopProPathname(siteUrl, "/")) {
        return true;
      }

      return false;
    }

    if (
      target.value === SIXSHOP_PRO_PAGE.LOGIN.target &&
      url.pathname ===
        getSixshopProPathname(siteUrl, SIXSHOP_PRO_PAGE.LOGIN.url)
    ) {
      return true;
    }

    if (
      target.value === SIXSHOP_PRO_PAGE.SIGNUP.target &&
      url.pathname ===
        getSixshopProPathname(siteUrl, SIXSHOP_PRO_PAGE.SIGNUP.url)
    ) {
      return true;
    }

    if (
      target.value === SIXSHOP_PRO_PAGE.FIND_PASSWORD.target &&
      url.pathname ===
        getSixshopProPathname(siteUrl, SIXSHOP_PRO_PAGE.FIND_PASSWORD.url)
    ) {
      return true;
    }

    if (
      target.value === SIXSHOP_PRO_PAGE.MY_PAGE.target &&
      url.pathname ===
        getSixshopProPathname(siteUrl, SIXSHOP_PRO_PAGE.MY_PAGE.url)
    ) {
      return true;
    }

    if (
      target.value === SIXSHOP_PRO_PAGE.CHECK_GUEST_ORDER.target &&
      url.pathname ===
        getSixshopProPathname(siteUrl, SIXSHOP_PRO_PAGE.CHECK_GUEST_ORDER.url)
    ) {
      return true;
    }

    if (target.value === SIXSHOP_PRO_PAGE.PRODUCT_CATEGORY.target) {
      const conditionParamValue = target.params?.categoryFilter || "";
      const productCategoryId =
        url.searchParams.get(SIXSHOP_PRO_PAGE.PRODUCT_CATEGORY.param) || "";

      if (productCategoryId === conditionParamValue) {
        return true;
      }
    }

    if (target.value === SIXSHOP_PRO_PAGE.PRODUCT_DETAIL.target) {
      const conditionPathname = target.params?.productSlug
        ? `${SIXSHOP_PRO_PAGE.PRODUCT_DETAIL.url}/${target.params.productSlug}`
        : `${SIXSHOP_PRO_PAGE.PRODUCT_DETAIL.url}`;
      if (
        url.pathname.startsWith(
          getSixshopProPathname(siteUrl, conditionPathname)
        )
      ) {
        return true;
      }
    }

    if (
      target.value === SIXSHOP_PRO_PAGE.CART.target &&
      url.pathname.startsWith(
        getSixshopProPathname(siteUrl, SIXSHOP_PRO_PAGE.CART.url)
      )
    ) {
      return true;
    }

    if (
      target.value === SIXSHOP_PRO_PAGE.ORDER.target &&
      url.pathname.startsWith(
        getSixshopProPathname(siteUrl, SIXSHOP_PRO_PAGE.ORDER.url)
      )
    ) {
      return true;
    }

    if (
      target.value === SIXSHOP_PRO_PAGE.POLICY.target &&
      url.pathname ===
        getSixshopProPathname(siteUrl, SIXSHOP_PRO_PAGE.POLICY.url)
    ) {
      return true;
    }

    if (
      target.value === SIXSHOP_PRO_PAGE.PRIVACY.target &&
      url.pathname ===
        getSixshopProPathname(siteUrl, SIXSHOP_PRO_PAGE.PRIVACY.url)
    ) {
      return true;
    }

    if (
      target.value === SIXSHOP_PRO_PAGE.SIGNUP_PRIVACY.target &&
      url.pathname ===
        getSixshopProPathname(siteUrl, SIXSHOP_PRO_PAGE.SIGNUP_PRIVACY.url)
    ) {
      return true;
    }

    return false;
  },
};

export default sixshop;
